import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import GameSummaryMobile from './GameSummaryMobile';
import { cleanProfanity } from '../../util/filterProfanity';

// Mobile-optimized version of GameSummaryWithControls for bookmarks
const GameSummaryWithControlsMobile = ({ game, folderName, folders, onDelete, onReorder, onMove, gameIndex, showControls, onToggleControls, allGamesInFolder }) => {
  const history = useHistory();

  // Handle navigation to the game with bookmark context
  const navigateToGame = () => {
    // Get all game IDs from the current folder for navigation
    const gameIds = allGamesInFolder ? allGamesInFolder.map(g => g.gameId) : [game.gameId];
    
    history.push(`/games/${game.gameId}`, {
      origin: 'BOOKMARKS',
      gameIds: gameIds,
      returnLabel: `Back to ${folderName}`,
      folderName: folderName
    });
  };


  // Process moves data to ensure it's an array
  const processMoves = () => {
    if (typeof game.moves === 'string') {
      try {
        return JSON.parse(game.moves);
      } catch (e) {
        console.error('Error parsing moves string:', e);
        return [];
      }
    }
    else if (Array.isArray(game.moves)) {
      return game.moves;
    }
    return [];
  };

  return (
    <div style={{ position: 'relative', width: '100%', overflow: 'visible' }}>
      {/* Custom game container with exact boardWidth and title */}
      <div
        style={{
          width: '150px', // Match exact boardWidth
          border: showControls ? '2px solid gold' : '1px solid #333', // Gold border when controls active
          borderRadius: '5px', // 5px radius for all elements
          backgroundColor: '#1a1a1a',
          overflow: 'visible', // Allow ellipsis button to show outside container
          position: 'relative',
          boxShadow: showControls ? '0 0 8px rgba(255, 215, 0, 0.3)' : 'none' // Subtle gold glow when selected
        }}
      >
        {/* Board area - clickable */}
        <div
          onClick={navigateToGame}
          style={{
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            padding: 0,
            margin: 0,
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
            overflow: 'hidden' // Ensure board respects the rounded corners
          }}
        >
          <GameSummaryMobile
            gameData={{
              id: game.gameId,
              creatorHandle: game.creatorHandle,
              caption: game.caption,
              tags: game.tags || [],
              moves: processMoves(),
              pov: game.pov
            }}
            variant="compact"
            boardWidth={150}
            showDetails={false}
            cornerRadius="5px"
            showBorder={false}
            theme="dark"
          />
        </div>

        {/* Title/Caption below the board */}
        <div style={{
          padding: '8px 8px 16px 8px', // Extra bottom padding for ellipsis spacing
          borderTop: '1px solid #333',
          backgroundColor: '#1a1a1a',
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px'
        }}>
          <div style={{
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold',
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: '1.2'
          }}>
            {cleanProfanity(game.caption) || 'Untitled Game'}
          </div>
        </div>

        {/* Ellipsis button at bottom edge */}
        {!showControls && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              onToggleControls(game.gameId);
            }}
            style={{
              position: 'absolute',
              bottom: '-18px',
              left: '50%',
              transform: 'translateX(-50%)',
              cursor: 'pointer',
              color: 'gold',
              fontSize: '16px',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.9)',
              border: '2px solid gold',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
              zIndex: 50 // Higher z-index to ensure it's not cut off
            }}
          >
            <i className="fa-solid fa-ellipsis"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameSummaryWithControlsMobile;